import { CircularProgress } from '@mui/material'

const LoadingComponent = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <CircularProgress color="primary" variant="indeterminate" />
    </div>
  )
}

export default LoadingComponent
